import { watchOnce } from '@vueuse/core';
import { useNavUser } from '~/stores/navUser';
import { storeToRefs } from 'pinia';

export default function onUserInit(cb) {
  const navUser = useNavUser();
  const { initialized } = storeToRefs(navUser);
  if (initialized.value) {
    cb();
    return;
  }

  watchOnce(initialized, cb);
}
